import * as yup from 'yup';
import { MAX_10_CHARS, INVALID_DATE_MESSAGE } from '@/lib/validations';

export const workdayValidationSchema = yup.object({
  workdayId: yup
    .string()
    .max(10, MAX_10_CHARS),
  workdayHireDate: yup
    .date()
    .transform((value) => (value instanceof Date && !isNaN(value) ? value : null))
    .nullable()
    .typeError(INVALID_DATE_MESSAGE)
    .when('workdayId', {
      is: (workdayId) => workdayId && workdayId.length > 0,
      then: (schema) => schema.required('Workday Hire Date is required when Workday ID is provided'),
      otherwise: (schema) => schema.test({
        name: 'prohibited-when-workday-id-empty',
        message: 'Workday Hire Date must be empty when Workday ID is not provided',
        test: (value) => !value,
      }),
    }),
});
